import { render, staticRenderFns } from "./CustomerSatisfactionPage.vue?vue&type=template&id=40129a0e&scoped=true&"
import script from "./CustomerSatisfactionPage.vue?vue&type=script&lang=js&"
export * from "./CustomerSatisfactionPage.vue?vue&type=script&lang=js&"
import style0 from "./CustomerSatisfactionPage.vue?vue&type=style&index=0&id=40129a0e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40129a0e",
  null
  
)

export default component.exports